const UNIT_CODE_ALIASES: Record<string, string> = {
    "": "",
    unknown: "",
    unknow: "",
    "%": "%",
    percent: "%",
    percentage: "%",
};

export const formatCsrStrategyUnitCode = (unitCode?: string | null): string => {
    const normalizedUnitCode = unitCode?.trim() ?? "";
    const normalizedAlias = normalizedUnitCode.toLowerCase();

    return UNIT_CODE_ALIASES[normalizedAlias] ?? normalizedUnitCode;
};
